<template>
  <div class="quick-actions">
    <div class="header">{{ $lang('快捷入口') }}</div>
    <div class="action-grid">
      <div :class="item.label ? 'action-item' : 'empty'" v-for="(item, index) in actions" :key="index" @click="handleClick(item)">
        <div class="icon-box">
          <img :src="item.img" alt="" />
        </div>
        <div class="label">{{ $lang(item.label) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import single from '../images/single.png'
import batch from '../images/batch.png'
import print from '../images/print.png'
import follow from '../images/follow.png'
import myOrder from '../images/my_order.png'
export default {
  name: 'QuickActions',
  data() {
    return {
      actions: [
        { label: '单票下单', img: single, url: '/singleOrder' },
        { label: '批量下单', img: batch, url: '/batchOrder' },
        { label: '打印面单', img: print, url: '/order' },
        { label: '快件跟踪', img: follow, url: '/expressTracking' },
        { label: '我的运单', img: myOrder, url: '/waybill' },
        {},
      ],
    }
  },
  methods: {
    handleClick(item) {
      if (item.url) {
        this.$router.push(item.url)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.quick-actions {
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  height: 418px; // To match the height of the left component
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .header {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 20px;
  }

  .action-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .action-item {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px 0;
      cursor: pointer;
      transition: all 0.3s;
      border-radius: 8px;
      margin-bottom: 16px;

      background-color: #f5f7fa;

      .icon-box {
        width: 50px;
        height: 50px;
        border-radius: 12px;
        background: #f5f7fa;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: #606266;
        margin-bottom: 10px;
        transition: all 0.3s;
      }

      &:hover .icon-box {
        background: #fff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        color: #ff4757;
      }

      .label {
        font-size: 14px;
        color: #606266;
        text-align: center;
      }
    }

    .empty {
      width: 30%;
    }
  }
}
</style>
